<div *ngIf="userLoaded">
   <!-- Inicio de sidebar -->
   <mat-sidenav-container>
      <mat-sidenav #sidenav="matSidenav">
         <div class="h-100 d-flex flex-column justify-content-between" *ngIf="!isDeveloper; else devMenu">
            <div>
               <div class="py-3" *ngIf="sidenav?.mode !== 'over'">
                  <a class="ms-3 d-flex justify-content-start cl-white cr-pointer pb-3"
                     (click)="link(path.ROUTE_DASHBOARD_HOME)">
                     <i class="mnf-monific-icon me-2 fs-28"></i>
                     <i class="mnf-monific mb-2 fs-22 my-auto"></i>
                  </a>
               </div>
               <mat-accordion>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item [routerLink]="path.ROUTE_DASHBOARD_HOME" [routerLinkActive]="'active-link'">
                        <img width="18" class="me-2" src="assets/icon/home-shell.svg" alt="home-icon">Inicio</a>
                  </mat-action-list>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item [routerLink]="[path.ROUTE_AVAILABLE_PROJECTS_HOME]" [routerLinkActive]="'active-link'">
                        <img width="18" class="me-2" src="assets/icon/invest-shell.svg" alt="invest-icon">Ir a invertir</a>
                  </mat-action-list>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item [routerLink]="path.ROUTE_MY_INVESTMENTS_HOME" [routerLinkActive]="'active-link'">
                        <img width="18" class="me-2" src="assets/icon/invest-bar-shell.svg" alt="invest-bar-icon">Mis inversiones</a>
                  </mat-action-list>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item [routerLink]="path.ROUTE_MOVE_HOME_V2" [routerLinkActive]="'active-link'">
                        <img width="18" class="me-2" src="assets/icon/movements-shell.svg" alt="movements-icon">Mis movimientos</a>
                  </mat-action-list>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item [routerLink]="path.ROUTE_CALENDAR_PAYMENTS_HOME" [routerLinkActive]="'active-link'">
                        <img width="18" class="me-2" src="assets/icon/calendar-shell.svg" alt="calendar-icon">Calendario</a>
                  </mat-action-list>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item [routerLink]="path.ROUTE_WALLET_HOME" [routerLinkActive]="'active-link'">
                        <img width="20" class="me-2 add-mny-icon white-filter" src="assets/icon/prevSwiperIcon.svg" alt="home-icon">Agregar fondos</a>
                  </mat-action-list>
                  <mat-action-list>
                     <a class="d-flex align-items-start" mat-list-item (click)="routeToWithdraw()" [routerLinkActive]="'active-link'">
                        <img width="20" class="me-2 rmv-mny-icon white-filter" src="assets/icon/prevSwiperIcon.svg" alt="home-icon">Retirar fondos</a>
                  </mat-action-list>
               </mat-accordion>
            </div>
            <div class="userBalance" *ngIf="user && user?.wallet">
               <div>
                  <p class="pt-3">Disponible:</p>
                  <p class="fw-sbold" [innerHTML]="balance"></p>
               </div>
               <div class="line"></div>
               <div>
                  <p>Valor de mi cuenta:</p>
                  <p class="fw-sbold pb-2" [innerHTML]="totalInvested"></p>
               </div>
            </div>
         </div>
      </mat-sidenav>

      <!-- Inicio de topbar -->
      <mat-sidenav-content #scrollable class="mat-drawer-content mat-sidenav-content bg-shell">
         <mat-toolbar class="d-flex justify-content-between justify-content-lg-end head top-bar" [ngClass]="{'ios': isiOSDevice, 'hidden': !isHeadVisible}">
            <div (click)="openModal('invest')"><img src="assets/icon/new-menu.svg" class="d-block d-lg-none px-3 menu-img cr-pointer" alt="#"></div>
            <span class="d-block d-lg-none">{{ actualRoute }}</span>
            <div class="d-block d-lg-none" #elemBtn *ngIf="isUserNoAuth != 1">
               <button (click)="openModal('account')"><img src="assets/icons/user-dashboard-icon.svg" class="account-icon" alt="#"></button>
            </div>
            <div class="d-none d-lg-flex" #elemBtn  *ngIf="isUserNoAuth != 1">
               <div class="bell-container d-none align-items-center">
                  <div class="vertical-line"></div>
                  <button><img width="24" src="assets/icon/new-bell.svg" alt="bell"></button>
                  <div class="vertical-line"></div>
                </div>
               <button (click)="divState()"><img src="assets/icons/user-dashboard-icon.svg" class="account-icon" alt="#"><i [ngClass]="showDiv ? 'rotate-icon' : ''" class="mnf-arrow fs-9 ms-2 mb-2"></i></button>
            </div>
         </mat-toolbar>
         <!-- router-outlet de los componentes sobre el shell -->
         <main class="mt-router router-wrapper overflow-lg-hidden">
            <div class="space-ios" [ngClass]="{'ios-space-shell' : isiOSDevice}">

            </div>
            <router-outlet #o="outlet" (activate)="onOutletActivate()"></router-outlet>
         </main>
         <div toastContainer></div>
      </mat-sidenav-content>
      <!-- Fin de topbar -->
   </mat-sidenav-container>
   <!-- Fin de sidebar -->

   <!-- Inicio de Bottom-bar -->
    <mat-toolbar class="bottom-bar d-flex d-lg-none">
      <div class="col-12 bottom-bar-height" [ngClass]="{'ios-footer': isiOSDevice}">
        <div class="row h-100">
          <div class="col-4 nav-item" [class.bottom-bar-select]="rla?.isActive">
            <a [routerLink]="isDeveloper ? path.ROUTE_DEVELOPER : path.ROUTE_DASHBOARD_HOME" #rla="routerLinkActive" [routerLinkActive]="'bottom-bar-select'">
              <img src="assets/icon/home-shell.svg" alt="home-icon">
              <span class="nav-text">Inicio</span>
            </a>
          </div>
          @if(!isDeveloper) {
            <div class="col-4 nav-item" [class.bottom-bar-select]="rla2?.isActive">
              <a [routerLink]="[path.ROUTE_AVAILABLE_PROJECTS_HOME]" #rla2="routerLinkActive" [routerLinkActive]="'bottom-bar-select'">
                <img src="assets/icon/invest-shell.svg" alt="invest-icon">
                <span class="nav-text">Invertir</span>
              </a>
            </div>
            <div class="col-4 nav-item" [class.bottom-bar-select]="rla3?.isActive">
              <a [routerLink]="path.ROUTE_MY_INVESTMENTS_HOME" #rla3="routerLinkActive" [routerLinkActive]="'bottom-bar-select'">
                <img src="assets/icon/invest-bar-shell.svg" alt="bar-invest-icon">
                <span class="nav-text">Mis inversiones</span>
              </a>
            </div>
          }
        </div>
      </div>
    </mat-toolbar>
    <!-- Fin de Bottom-bar -->
</div>

<!-- Inicio menu de desarrollador -->
<ng-template #devMenu>
   <div>
      <div class="py-3">
         <a class="d-flex justify-content-center cl-white cr-pointer py-3" (click)="link(path.ROUTE_DEVELOPER)">
            <img src="assets/app-icons/monific_dev.png" width="215px" />
         </a>
      </div>
      <mat-accordion>
         <mat-action-list>
            <button mat-list-item (click)="link(path.ROUTE_DEVELOPER)">
               <i class="mnf-invest me-2"></i> Inicio </button>
         </mat-action-list>
         <mat-expansion-panel #myAccount>
            <mat-expansion-panel-header>
               <mat-panel-title>
                  <i class="mnf-account me-2"></i>
                  Mi cuenta<strong class="ms-1"></strong>
               </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-action-list *ngIf="regStep === 2 else completeRegisterDev">
               <button mat-list-item (click)="link(path.ROUTE_DEVELOPER_FORM)">Completar registro</button>
            </mat-action-list>
            <ng-template #completeRegisterDev>
               <mat-action-list *ngIf="regStep === 3">
                <button mat-list-item (click)="link(path.ROUTE_DEVELOPER_MY_MOVEMENTS)" (click)="closeSubmenu(myAccount)"> Movimientos y saldos </button>
                <button mat-list-item (click)="link(path.ROUTE_DEVELOPER_INFO_PROFILE)" (click)="closeSubmenu(myAccount)"> Mis datos </button>
                <button mat-list-item (click)="link(path.ROUTE_DEVELOPER_DOCUMENTS_PROFILE)" (click)="closeSubmenu(myAccount)"> Mis documentos </button>
                <button mat-list-item (click)="link(path.ROUTE_DEVELOPER_CONFIG)" (click)="closeSubmenu(myAccount)"> Ajustes </button>
               </mat-action-list>
            </ng-template>
         </mat-expansion-panel>
         <mat-action-list>
            <button mat-list-item (click)="logout()">
               <i class="mnf-out me-2"></i> Cerrar sesión </button>
         </mat-action-list>
      </mat-accordion>
      <p class="version" style="position: absolute;">
         <span *ngIf="user?.lastSession">Última sesión: {{ user.lastSession | date: 'dd/MM/yy HH:mm' }}</span>
         <span>{{ version }}</span>
      </p>
   </div>
</ng-template>
<!-- Fin menu de desarrollador -->

<!-- Modales para menus en mobile  -->
<div class="modal-container" *ngIf="investModal">
   <div class="d-block d-lg-none">
     <div class="modal fade" id="investModal" tabindex="-1" #modalOne>
       <div class="modal-dialog">
         <div class="modal-content rounded-3 mt-8">
           <div class="modal-body">
             <div class="col-12">
               <div class="row">
                 <div class="col-12 mt-3">
                   <div class="d-flex justify-content-between" *ngIf="!isDeveloper">
                     <a [routerLink]="[path.ROUTE_AVAILABLE_PROJECTS_HOME]" class="cl-black fs-16"><img class="ms-2 me-2 mb-1 rotate-img" src="assets/icons/invest-modal.svg" alt="navbar-arrow-icon">Ir a invertir</a>
                     <img class="img-close" src="assets/icon/x.svg" alt="close" (click)="closeModal('invest')">
                   </div>
                 </div>
                 <div class="col-12 my-4" *ngIf="!isDeveloper">
                   <a [routerLink]="[path.ROUTE_CALENDAR_PAYMENTS_HOME]" class="cl-black fs-16 w-100 d-block"><img class="ms-2 me-2 mb-1 rotate-img" src="assets/icons/calendar-modal.svg" alt="navbar-arrow-icon">Calendario</a>
                 </div>
                 <div class="col-12">
                   <a [routerLink]="isDeveloper ? [path.ROUTE_DEVELOPER_MY_MOVEMENTS] : [path.ROUTE_MOVE_HOME_V2]" class="cl-black fs-16 w-100 d-block"><img class="ms-2 me-2 mb-1 rotate-img" src="assets/icons/movements-modal.svg" alt="navbar-arrow-icon">Movimientos</a>
                 </div>
                 <div class="line mt-2 mb-3"></div>
                 <div class="col-12 mt-3" *ngIf="!isDeveloper">
                   <div class="d-flex align-items-center justify-content-center flex-column">
                     <a [routerLink]="path.ROUTE_WALLET_HOME" class="btn bg-primary rounded-4 py-60 cl-white w-100 btn-shadow"><img src="assets/icon/prevSwiperIcon.svg" class="add-mny-icon modal-icons white-filter" alt="arrow-icon">Agregar fondos</a>
                     <div class="d-flex align-items-center my-4 w-100">
                       <div class="flex-grow-1 border-bottom"></div>
                     </div>
                     <a (click)="routeToWithdraw()" class="btn border-primary rounded-4 bg-white py-60 cl-primary w-100 mb-2"><img src="assets/icon/prevSwiperIcon.svg" class="rmv-mny-icon modal-icons primary-filter" alt="arrow-icon">Retirar fondos</a>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
</div>

<div class="modal-container" [hidden]="accountModal">
   <div class="d-block d-lg-none">
     <div class="modal fade" id="accountModal" tabindex="-1" #modalTwo>
       <div class="modal-dialog">
         <div class="modal-content rounded-3 mt-8">
           <div class="modal-body px-0 pt-2">
            <div class="col-12 mt-3 px-4 pb-1">
               <div class="d-flex justify-content-between">
                 <a [routerLink]="isDeveloper ? path.ROUTE_DEVELOPER_INFO_PROFILE : path.ROUTE_MY_ACCOUNT_HOME" class="w-100 cl-black fs-16 panel-a">Mi cuenta</a>
                 <img class="img-close" src="assets/icon/x.svg" alt="close" (click)="closeModal('account')">
               </div>
             </div>
            <mat-accordion class="" [multi]="true">
               <mat-expansion-panel class="mb-0 modal-panel">
                 <mat-expansion-panel-header class="modal-header">
                   <mat-panel-title class="modal-mat-title px-4 fs-16 cl-black">Ajustes</mat-panel-title>
                 </mat-expansion-panel-header>
                 <a class="a-hov" [routerLink]="isDeveloper ? path.ROUTE_DEVELOPER_INFO_PROFILE :  path.ROUTE_MY_PROFILE_HOME">
                  <p class="fw-sbold cl-black mb-2 fs-14 px-4 mt-2">Perfil</p>
                  <p class="cl-black px-4 border-bottom mb-0 pb-2">Actualización de mis datos personales</p>
                 </a>
                 <a class="a-hov" [routerLink]="isDeveloper ? path.ROUTE_DEVELOPER_CONFIG : path.ROUTE_MY_SETTINGS_HOME">
                  <p class="fw-sbold cl-black mb-2 fs-14 px-4 pt-2">Ajustes de mi cuenta</p>
                  <p class="cl-black px-4 border-bottom mb-0 pb-2">Preferencias de mi cuenta</p>
                 </a>
               </mat-expansion-panel>
               <mat-expansion-panel disabled>
                 <mat-expansion-panel-header>
                  @if(!isDeveloper) {
                    <mat-panel-title>
                      <a [routerLink]="path.ROUTE_REFERENCED_USERS" class="w-100 cl-black fs-16 px-4 panel-a">Programa de referidos</a>
                    </mat-panel-title>
                  }
                 </mat-expansion-panel-header>
               </mat-expansion-panel>
               @if(!isDeveloper) {
                <mat-expansion-panel class="mt-0">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="px-4 fs-16 cl-black">Documentos</mat-panel-title>
                  </mat-expansion-panel-header>
                  <a class="a-hov" [routerLink]="path.ROUTE_MY_STATEMENT_HOME">
                   <p class="fw-sbold cl-black mb-2 fs-14 px-4 mt-2">Estados de cuenta</p>
                   <p class="cl-black px-4 border-bottom mb-0 pb-2">Descarga de tus estados mensuales</p>
                  </a>
                  <a class="a-hov" [routerLink]="path.ROUTE_MY_DOCUMENTS_HOME">
                   <p class="fw-sbold cl-black mb-2 fs-14 px-4 pt-2">Documentos</p>
                   <p class="cl-black px-4 border-bottom mb-0 pb-2">Accede a tus documentos con Monific</p>
                  </a>
                </mat-expansion-panel>
               }
             </mat-accordion>
             <div class="col-12 mt-3 px-4">
               <div class="d-flex align-items-center justify-content-center flex-column">
                 <a (click)="logout()" class="btn bg-primary rounded-4 py-60 cl-white w-100 btn-shadow fw-sbold mb-3 fs-15">Cerrar sesión</a>
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
</div>

<div class="px-0 pt-2 box-shell" *ngIf="showDiv">
  @if (!isDeveloper) {
   <div class="col-12 mt-3 px-4 pb-1">
        <a [routerLink]="path.ROUTE_MY_ACCOUNT_HOME" class="w-100 cl-black fs-16 panel-a">Mi cuenta</a>
    </div>
    }
   <mat-accordion [multi]="true">
      <mat-expansion-panel class="mb-0">
        <mat-expansion-panel-header>
          <mat-panel-title class="px-4 fs-16 cl-black">Ajustes</mat-panel-title>
        </mat-expansion-panel-header>
        @if (!isDeveloper) {
          <a class="a-hov" [routerLink]="path.ROUTE_MY_PROFILE_HOME">
           <p class="fw-sbold cl-black mb-2 fs-14 px-4 mt-2">Perfil</p>
           <p class="cl-black px-4 border-bottom mb-0 pb-2">Actualización de mis datos personales</p>
          </a>
        } @else {
          <a class="a-hov" [routerLink]="path.ROUTE_DEVELOPER_INFO_PROFILE">
           <p class="fw-sbold cl-black mb-2 fs-14 px-4 mt-2">Perfil</p>
           <p class="cl-black px-4 border-bottom mb-0 pb-2">Actualización de mis datos personales</p>
          </a>
        }
        @if (!isDeveloper) {
          <a class="a-hov" [routerLink]="path.ROUTE_MY_SETTINGS_HOME">
           <p class="fw-sbold cl-black mb-2 fs-14 px-4 pt-2">Ajustes de mi cuenta</p>
           <p class="cl-black px-4 border-bottom mb-0 pb-2">Preferencias de mi cuenta</p>
          </a>
        } @else {
          <a class="a-hov" [routerLink]="path.ROUTE_DEVELOPER_CONFIG">
            <p class="fw-sbold cl-black mb-2 fs-14 px-4 pt-2">Ajustes de mi cuenta</p>
            <p class="cl-black px-4 border-bottom mb-0 pb-2">Preferencias de mi cuenta</p>
          </a>
        }
      </mat-expansion-panel>
      @if (!isDeveloper) {
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <a [routerLink]="path.ROUTE_REFERENCED_USERS" class="w-100 cl-black fs-16 px-4 panel-a">Programa de referidos</a>
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      }
      <mat-expansion-panel class="mt-0">
        <mat-expansion-panel-header>
          <mat-panel-title class="px-4 fs-16 cl-black">Documentos</mat-panel-title>
        </mat-expansion-panel-header>
        @if(!isDeveloper) {
          <a class="a-hov" [routerLink]="path.ROUTE_MY_STATEMENT_HOME">
            <p class="fw-sbold cl-black mb-2 fs-14 px-4 mt-2">Estados de cuenta</p>
            <p class="cl-black px-4 border-bottom mb-0 pb-2">Descarga de tus estados mensuales</p>
          </a>
          <a class="a-hov" [routerLink]="path.ROUTE_MY_DOCUMENTS_HOME">
            <p class="fw-sbold cl-black mb-2 fs-14 px-4 pt-2">Documentos</p>
            <p class="cl-black px-4 border-bottom mb-0 pb-2">Accede a tus documentos con Monific</p>
          </a>
        } @else {
          <a class="a-hov" [routerLink]="path.ROUTE_DEVELOPER_MY_MOVEMENTS_OPERATION_STATUS">
            <p class="fw-sbold cl-black mb-2 fs-14 px-4 mt-2">Estados de cuenta</p>
            <p class="cl-black px-4 border-bottom mb-0 pb-2">Descarga de tus estados mensuales</p>
          </a>
          <a class="a-hov" [routerLink]="path.ROUTE_DEVELOPER_DOCUMENTS_PROFILE">
            <p class="fw-sbold cl-black mb-2 fs-14 px-4 pt-2">Documentos</p>
            <p class="cl-black px-4 border-bottom mb-0 pb-2">Accede a tus documentos con Monific</p>
          </a>
        }
      </mat-expansion-panel>
    </mat-accordion>
    <div class="col-12 mt-3 px-4">
      <div class="d-flex align-items-center justify-content-center flex-column">
        <a (click)="logout()" class="btn bg-primary rounded-4 py-60 cl-white w-100 btn-shadow fw-sbold mb-3 fs-15">Cerrar sesión</a>
      </div>
    </div>
</div>